<template>
<div class="chapter">
<div class="inner_page">
      ﻿




<title>Abbreviations</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="abbreviations">
<p class="chap-ttl"><a id="pxi"></a><a href="#/Table_of_contents">Abbreviations</a></p>
<p class="AB">AB    Anchor Bible</p>
<p class="AB"><span class="epub-italic-normal-normal">ANF</span>    <span class="epub-italic-normal-normal">The Ante-Nicene Fathers: Translation of the Writings of the Fathers Down to A.D. 325 </span>(Grand Rapids: Eerdmans,1956–62 [1885–96])</p>
<p class="AB"><span class="epub-italic-normal-normal">ANRW</span>     <span class="epub-italic-normal-normal">Aufstieg und Niedergang der römischen Welt: Geschichte und Kultur Roms im Spiegel der neueren Forschung</span>, ed. H. Temporini and W. Haase (Berlin, 1972–)</p>
<p class="AB"><span class="epub-italic-normal-normal">AV</span>/KGB     Authorized Version/King James Bible</p>
<p class="AB">BDAG    W. Bauer, F. W. Danker, W. F. Arndt and F. W. Gingrich, <span class="epub-italic-normal-normal">A Greek-English Lexicon of the New Testament and Other Early Christian Literature</span>(Chicago: University of Chicago Press, 3rd edn, 2000)</p>
<p class="AB">BDB     F. Brown, S. R. Driver and C. A. Briggs, <span class="epub-italic-normal-normal">Hebrew and English Lexicon of the Old Testament</span>  (Lafayette, IN: Associated Publishers, 1980)</p>
<p class="AB"><span class="epub-italic-normal-normal">BI</span>    <span class="epub-italic-normal-normal">Biblical Interpretation</span></p>
<p class="AB">BZNW    Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p>
<p class="AB"><span class="epub-italic-normal-normal">CBQ</span>    <span class="epub-italic-normal-normal">Catholic Biblical Quarterly</span></p>
<p class="AB">EKKNT    Evangelisch-katholischer Kommentar zum Neuen Testament</p>
<p class="AB"><span class="epub-italic-normal-normal">EQ</span>    <span class="epub-italic-normal-normal">Evangelical Quarterly</span></p>
<p class="AB"><span class="epub-italic-normal-normal">ExGrT</span>    <span class="epub-italic-normal-normal">Expositor’s Greek Testament</span></p>
<p class="AB">FRLANT    Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p>
<p class="AB"><span class="epub-italic-normal-normal">HTR</span>    <span class="epub-italic-normal-normal">Harvard Theological Review</span></p>
<p class="AB"><span class="epub-italic-normal-normal">IB</span>    <span class="epub-italic-normal-normal">Interpreter’s Bible</span></p>
<p class="AB">ICC    International Critical Commentary</p>
<p class="AB"><span class="epub-italic-normal-normal">Int</span>     <span class="epub-italic-normal-normal">Interpretation</span></p>
<p class="AB">JAC     Jahrbuch für Antike und Christentum</p>
<p class="AB">JB     Jerusalem Bible</p>
<p class="AB"><span class="epub-italic-normal-normal">JBL</span>    <span class="epub-italic-normal-normal">Journal of Biblical Literature</span></p>
<p class="AB"><span class="epub-italic-normal-normal">JCE</span>     <span class="epub-italic-normal-normal">Journal of Christian Education</span></p>
<p class="AB"><span class="epub-italic-normal-normal">JPT</span>     <span class="epub-italic-normal-normal">Journal of Pentecostal Theology</span></p>
<p class="AB"><span class="epub-italic-normal-normal">JRH</span>    <span class="epub-italic-normal-normal">Journal of Religious History</span></p>
<p class="AB"><span class="epub-italic-normal-normal">JSNT</span>    <span class="epub-italic-normal-normal">Journal for the Study of the New Testament</span></p>
<p class="AB">JSNTMS    Journal for the Study of the New Testament Monograph Series</p>
<p class="AB">JSNTSup    Journal for the Study of the New Testament: Supplement Series</p>
<p class="AB"><span class="epub-italic-normal-normal">JSOT</span>    <span class="epub-italic-normal-normal">Journal for the Study of the Old Testament</span></p>
<p class="AB"><span class="epub-italic-normal-normal">JTS</span>    <span class="epub-italic-normal-normal">Journal of Theological Studies</span></p>
<p class="AB">LCC    Library of Christian Classics</p>
<p class="AB">LCL    Loeb Classical Library</p>
<p class="AB">LXX     Septuagint</p>
<p class="AB">NCB    New Century Bible</p>
<p class="AB">NEB    New English Bible</p>
<p class="AB"><span class="epub-italic-normal-normal">NIB</span>    <span class="epub-italic-normal-normal">New Interpreter’s Bible</span></p>
<p class="AB">NICNT    New International Commentary on the New Testament</p>
<p class="AB">NIGTC    New International Greek Testament Commentary</p>
<p class="AB">NIV    New International Version</p>
<p class="AB">NJB    New Jerusalem Bible</p>
<p class="AB">NovTSup    Novum Testamentum: Supplement Series</p>
<p class="AB"><span class="epub-italic-normal-normal">NPNF</span>    <span class="epub-italic-normal-normal">Library of Nicene and Post-Nicene Fathers of the Christian Church</span>, ed. Philip Schaff (ser. i, 14 vols); ed. Philip Schaff with Henry Wace (ser. ii, 14 vols, Edinburgh: T &amp; T Clark; repr. Grand Rapids: Eerdmans, 1991–)</p>
<p class="AB">NRSV     New Revised Standard Version</p>
<p class="AB"><span class="epub-italic-normal-normal">NTS</span>    <span class="epub-italic-normal-normal">New Testament Studies</span></p>
<p class="AB">PG     Patrologiae cursus completus: Series Graeca, ed. Jacques-Paul Migne (Paris: Garnier, 1844–65) (known as Patrologia Graeca)</p>
<p class="AB">PL     Patrologiae cursus completus: Series Latina, ed. Jacques-Paul Migne (Paris: Garnier, 1844–65) (known as Patrologia Latina)</p>
<p class="AB">REB     Revised English Bible</p>
<p class="AB">RSV     Revised Standard Version</p>
<p class="AB">RV    Revised Version</p>
<p class="AB">SBLDS    Society of Biblical Literature Dissertation Series</p>
<p class="AB">SBT    Studies in Biblical Theology</p>
<p class="AB"><span class="epub-italic-normal-normal">SJT</span>    <span class="epub-italic-normal-normal">Scottish Journal of Theology</span></p>
<p class="AB">SNTSMS     Society for New Testament Studies Monograph Series</p>
<p class="AB"><span class="epub-italic-normal-normal">TDNT</span>    <span class="epub-italic-normal-normal">Theological Dictionary of the New Testament</span>, ed. G. Kittel and G. Friedrich (10 vols, Grand Rapids, Eerdmans, 1964–76)</p>
<p class="AB"><span class="epub-italic-normal-normal">TDOT</span>    <span class="epub-italic-normal-normal">Theological Dictionary of the Old Testament</span>, ed. G. J. Botterweck and H. Ringgren (15 vols, Grand Rapids: Eerdmans, 1974–)</p>
<p class="AB">UBS    United Bible Societies</p>
<p class="AB">WBC    Word Biblical Commentary</p>
<p class="AB">WUNT    Wissenschaftliche Untersuchungen zum Neuen Testament</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?1a1d5e0c